import { toast } from "react-toastify";
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";

export async function EliminarCotizacion(id, status, onRefresh) {

  const confirm = window.confirm("Se eliminarán todos los pagos, servicios y procesos asociados a esta cotización, ¿Estás seguro de querer eliminar la cotización?");

  if (!confirm) {
    return;
  }

  const toastId = toast.loading("Eliminando cotización...");

  try {

    const services = await axios.get(`${BACKEND}/api/serviciosCotizaciones?where[cotizacion][equals]=${id}`);
    const payments = await axios.get(`${BACKEND}/api/pagosCotizaciones?where[cotizacion][equals]=${id}`);

    if (services.data.docs.length > 0) {
      for (const service of services.data.docs) {
        if (status === "Exito") {
          await deleteProcess(service.id);
        }
        await axios.delete(`${BACKEND}/api/serviciosCotizaciones/${service.id}`)
      }
    }

    if (payments.data.docs.length > 0) {
      for (const payment of payments.data.docs) {
        await axios.delete(`${BACKEND}/api/pagosCotizaciones/${payment.id}`);
      }
    }
    
    await axios.delete(`${BACKEND}/api/cotizaciones/${id}`);
    
    toast.update(toastId, {
      render: "Cotización eliminada correctamente",
      type: "success",
      isLoading: false,
      autoClose: 3000
    });

  } catch (e) {
    toast.update(toastId, {
      render: "Error al eliminar la cotización: " + e,
      type: "error", 
      isLoading: false,
      autoClose: 3000
    });
  } finally {
    onRefresh();
  }
}


const deleteProcess = async (serviceId) => {
  try {
    const response = await axios.post(`${BACKEND}/api/processMiddleware/eliminateProcess`, {
      serviceId: serviceId
    })
    console.log(response);
  } catch (error) {
    throw new Error(error);
  }
}